import * as React from 'react';

import { Card, CardContent } from '../layout/card';
import { Text } from '../typography/text';

export type AdminKpiCardProps = {
  title: string;
  value: string | number;
  supportingText?: string;
  className?: string;
};

export function AdminKpiCard({ title, value, supportingText, className }: AdminKpiCardProps) {
  return (
    <Card className={className}>
      <CardContent className="p-4">
        <Text size="sm" color="muted">
          {title}
        </Text>
        <Text className="mt-2 text-2xl font-bold text-card-foreground">{value}</Text>
        {supportingText ? (
          <Text size="sm" color="muted" className="mt-1">
            {supportingText}
          </Text>
        ) : null}
      </CardContent>
    </Card>
  );
}
